import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import { getDataAnalyticsConfig } from "@/Redux/Ducks/dataAnalyticsSlice";
import { getScreenConfig } from "@/Redux/Ducks/entryFormSlice";
import { getUserObjects, setSideBarState } from "@/Redux/Ducks/homeSlice";
import { getReportConfig } from "@/Redux/Ducks/reportExplorerSlice";
import { setActiveTab } from "@/Redux/Ducks/tabSlice";
import { KeyValueObject } from "@/UI/Interfaces/IBaseUI";
import { ControlTranslation } from "AlignComponents";
import { useEffect, useRef, useState } from "react";
import { FaLink, FaRegEdit } from "react-icons/fa";
import { FiBox, FiEdit, FiFile, FiHome, FiPieChart, FiSettings } from "react-icons/fi";
import { HiOutlineDatabase, HiOutlineDocumentReport } from "react-icons/hi";
import { useHistory } from "react-router";
import { AlignUIRender } from "./indexUI";
import ModuleIcon from "./ModuleIcon";

const Aside = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const sideBarState = useAppSelector((state) => state.Home.sideBarState);
  const companyInformation = useAppSelector((state) => ({
    companyLogo: state.User.UserLegalEntity.find(x => x.legalentityno == state.User.selectedLegalEntity)?.logoimage || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQpZaeWxczipxrTdSIThz5hmwrRYhEeeAl5A&s',
    companyName: state.User.UserLegalEntity.find(x => x.legalentityno == state.User.selectedLegalEntity)?.legalentitystxt || 'Company Name',
  }));
  const { userObjects, dataLoading, isAdmin } = useAppSelector(x => ({
    userObjects: x.Home.userObjects,
    dataLoading: x.Home.userObjectsLoading,
    isAdmin: x.User.user.peoplenestadmin
  }));

  var mainMenu = [
    {
      id: "Home",
      title: <ControlTranslation system={true} controlId="lblhome" />,
      routeTo: "/",
      icon: <FiHome size={16} />,
      onClick: () => {
        routeToSpecific("")
      }
    },
    // {
    //   id: "HrDocuments",
    //   title: <ControlTranslation system={true} controlId="lblhrdocuments" />,
    //   routeTo: "/Hr-Documents",
    //   icon: <FiFile size={16} />,
    //   onClick: () => {
    //     routeToSpecific("Hr-Documents")
    //   }
    // },
    {
      id: "Dashboard",
      title: <ControlTranslation system={true} controlId="lbldashboard" />,
      routeTo: "/Dashboard",
      icon: <FiPieChart size={16} />,
      onClick: () => {
        routeToSpecific("Dashboard")
      },
      hide: !isAdmin
    },
    // {
    //   id: "Workspace",
    //   title: <ControlTranslation system={true} controlId="lblworkspace" />,
    //   routeTo: "/Workspace",
    //   icon: <FiBox size={16} />,
    //   onClick: () => {
    //     routeToSpecific("Workspace")
    //   }
    // }
  ];

  var [moduleMenu, setModuleMenu] = useState<any>([]);
  var [requestMenu, setRequestMenu] = useState<any>([]);
  const [sideBarPinned, pinSideBar] = useState<boolean>(sideBarState == "pinned" ? true : false);
  const [settingAllowed, allowSetting] = useState<boolean>(false);
  const mainMenuRef = useRef<any>(null);
  const requestMenuRef = useRef<any>(null);
  const moduleMenuRef = useRef<any>(null);

  const init = async () => {
    if (!dataLoading && !userObjects.length) {
      dispatch(getUserObjects());
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (userObjects.length >= 1) {
      if (userObjects.find(x => x.objectcontrollerno == "OSLE")?.objectcontrollerno) {
        allowSetting(true);
      }

      const modulesMap: KeyValueObject = {};

      userObjects.forEach((object) => {
        const {
          moduleno,
          modulestxt,
          groupindex,
          groupstxt,
          objectcontrollerstxt,
          applicationobjecttype,
          objectcontrollerno,
          issetting,
        } = object;

        // Create module if it doesn't exist
        if (!modulesMap[moduleno]) {
          modulesMap[moduleno] = {
            id: moduleno,
            title: modulestxt,
            icon: <ModuleIcon moduleno={moduleno} />,
            subMenu: [],
          };
        }

        // Create or find the "Settings" group for items with issetting = true
        if (issetting) {
          const settingsGroupId = `${moduleno}-settings`;
          let settingsGroup = modulesMap[moduleno].subMenu.find(
            (g: any) => g.id === settingsGroupId
          );

          if (!settingsGroup) {
            settingsGroup = {
              id: settingsGroupId,
              title: "Settings"
              // + "(" + objectcontrollerstxt + ")"
              ,
              subMenu: [],
              icon: <FiSettings className="16" />,
              onClick: () => {
                if (applicationobjecttype === "E") {
                  dispatch(getScreenConfig({ processCode: objectcontrollerno }));
                }
              },
            };
            modulesMap[moduleno].subMenu.push(settingsGroup);
          }
        }
        // Create or find the "Reports" group for "R" or "I" types
        else if (applicationobjecttype === "R" || applicationobjecttype === "I") {
          const reportsGroupId = `${moduleno}-reports`;
          let reportsGroup = modulesMap[moduleno].subMenu.find(
            (g: any) => g.id === reportsGroupId
          );

          if (!reportsGroup) {
            reportsGroup = {
              id: reportsGroupId,
              title: "Reports",
              icon: <HiOutlineDocumentReport className="16" />,
              subMenu: [],
            };
            modulesMap[moduleno].subMenu.push(reportsGroup);
          }

          // Add the report or analytics item under the "Reports" group
          reportsGroup.subMenu.push({
            id: objectcontrollerno,
            title: objectcontrollerstxt,
            onClick: () => {
              if (applicationobjecttype === "R") {
                dispatch(getReportConfig({ reportObjectno: objectcontrollerno }));
              } else if (applicationobjecttype === "I") {
                dispatch(getDataAnalyticsConfig({ dataAnalyticsno: objectcontrollerno }));
              }
            },
          });
        }
        else {
          // Check if group exists in the subMenu array, if not, add it
          const groupId = `${moduleno}-${groupindex}`;
          let group = modulesMap[moduleno].subMenu.find((g: any) => g.id === groupId);

          if (!group) {
            group = {
              id: groupId,
              title: groupstxt,
              icon: <FaRegEdit className="16" />,
              subMenu: [],
            };
            modulesMap[moduleno].subMenu.push(group);
          }

          // Add the item to the group
          group.subMenu.push({
            id: objectcontrollerno,
            title: objectcontrollerstxt,
            onClick: () => {
              if (applicationobjecttype === "E") {
                dispatch(getScreenConfig({ processCode: objectcontrollerno }));
              }
            },
          });
        }
      });

      // Convert modulesMap to an array
      setModuleMenu(Object.values(modulesMap));

      setRequestMenu(userObjects.filter(x => x.objectcontrollerno.isEqual("TMAR", "TMRN")).map(x => ({
        id: x.objectcontrollerno,
        title: x.objectcontrollerstxt,
        routeTo: "/",
        icon: <FaLink size={16} />,
        onClick: () => {
          routeToObject(x.objectcontrollerno, x.applicationobjecttype)
        }
      })));


    }
  }, [userObjects])

  const switchSideBarState = () => {
    if (sideBarState == "pinned") {
      pinSideBar(!sideBarPinned)
      dispatch(setSideBarState("unpinned"))
      mainMenuRef.current?.closeMenu();
      moduleMenuRef.current?.closeMenu();
      requestMenuRef.current?.closeMenu();
    }
    else {
      pinSideBar(!sideBarPinned)
      dispatch(setSideBarState("pinned"))
    }
  }

  const forcePinSideBar = () => {
    if (sideBarState != "pinned") {
      pinSideBar(!sideBarPinned)
      dispatch(setSideBarState("pinned"))
    }
  }

  const routeToSpecific = (routeTo: string) => {
    dispatch(setActiveTab(""));
    history.push(`/${routeTo}`);
  };

  const routeToObject = (screenCode: string, applicationobjecttype: string) => {
    if (applicationobjecttype == "E") {
      dispatch(getScreenConfig({ processCode: screenCode }));
    }
    else if (applicationobjecttype == "R") {
      dispatch(getReportConfig({ reportObjectno: screenCode }));
    }
    else if (applicationobjecttype == "I") {
      dispatch(getDataAnalyticsConfig({ dataAnalyticsno: screenCode }));
    }
  };

  return AlignUIRender({ sideBarPinned, settingAllowed, mainMenu, mainMenuRef, requestMenu, requestMenuRef, moduleMenu, moduleMenuRef, switchSideBarState, forcePinSideBar, companyInformation, routeToObject, routeToSpecific });
};

export default Aside;

declare type StateFromProps = {
  history: any;
};

declare type ComponentProps = StateFromProps;